"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrganizationsRequest = fetchOrganizationsRequest;
const api_1 = require("../utils/api");
async function fetchOrganizationsRequest() {
    const { data } = await api_1.api.get("/orgs");
    return data;
}
